import { handler as locationSuggestionsQuery } from "./locationSuggestionsQuery";
import { handler as updateCartLocationMutationHandler } from "./updateCartLocation.mutation";

export const locationSelectorHandlers = [
  locationSuggestionsQuery,
  updateCartLocationMutationHandler,
];
